/* unplugin-vue-components disabled */import script from "./CurrencyExchangeNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./CurrencyExchangeNotification.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__